var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.458745 1.87312C0.0682211 1.4826 0.0682211 0.849433 0.458745 0.458909C0.84927 0.0683845 1.48243 0.0683845 1.87296 0.458909L0.458745 1.87312ZM13.5396 12.1256C13.9302 12.5161 13.9302 13.1493 13.5396 13.5398C13.1491 13.9303 12.5159 13.9303 12.1254 13.5398L13.5396 12.1256ZM1.87296 13.5398C1.48244 13.9303 0.849271 13.9303 0.458747 13.5398C0.068222 13.1493 0.068222 12.5161 0.458747 12.1256L1.87296 13.5398ZM12.1254 0.458909C12.5159 0.0683845 13.1491 0.0683845 13.5396 0.458909C13.9302 0.849433 13.9302 1.4826 13.5396 1.87312L12.1254 0.458909ZM1.87296 0.458909L13.5396 12.1256L12.1254 13.5398L0.458745 1.87312L1.87296 0.458909ZM0.458747 12.1256L12.1254 0.458909L13.5396 1.87312L1.87296 13.5398L0.458747 12.1256Z",
    fill: "#B29E72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.749cf08d06fb26710fa4ceaa5aa4832e.svg";
export { ForwardRef as ReactComponent };